import React from 'react';
import { Flex, Text, VStack } from '@chakra-ui/react';

// A labeled group of wrapping pills — "Type of Content", "Filter per Topic", etc.
const FilterGroup = ({ title, children }: { title: string; children: React.ReactNode }) => (
  <VStack align="stretch" gap="12px" width="100%">
    <Text fontSize="15px" fontWeight={600} color="text.mediumGray">
      {title}
    </Text>
    <Flex wrap="wrap" gap="10px">
      {children}
    </Flex>
  </VStack>
);

export default FilterGroup;
